import { PoChartSerie } from '@po-ui/ng-components';

/**
 * O tooltip do `po-chart` é configurado por série, não por ponto. Por isso só a série de
 * um ponto só recebe texto customizado: ali ele é o valor daquele ponto, e continua
 * correto. Numa série com vários pontos, o mesmo texto apareceria em todos — o tooltip
 * nativo, que sabe o valor de cada um, é melhor.
 */
export function withSinglePointTooltip(serie: PoChartSerie, value?: string): PoChartSerie {
  const data = serie.data;
  if (!value || !Array.isArray(data) || data.length !== 1) { return serie; }
  return { ...serie, tooltip: `${serie.label}: ${value}` };
}
